module.exports = __webpack_public_path__ + "img/detail-404.cf5da661.png";